const CRM_ID_FIELD = 'crm_id';

export const CRM_ID_REQUIRED_MESSAGE = 'Данный запрос нуждается в передаче crm_id';

function isEmptyCrmIdValue(value: unknown): boolean {
    if (value === undefined || value === null) return true;
    if (typeof value === 'string') return value.trim() === '';
    if (typeof value === 'number') return Number.isNaN(value);
    return false;
}

function readCrmIdField(source: unknown): { present: boolean; value?: unknown } {
    if (!source) return { present: false };
    if (source instanceof FormData) {
        return source.has(CRM_ID_FIELD)
            ? { present: true, value: source.get(CRM_ID_FIELD) }
            : { present: false };
    }
    if (typeof source === 'object' && CRM_ID_FIELD in (source as Record<string, unknown>)) {
        return { present: true, value: (source as Record<string, unknown>)[CRM_ID_FIELD] };
    }
    return { present: false };
}

/**
 * Проверяет payload и query-параметры запроса на пустой crm_id (undefined/null/'').
 * Если ключ crm_id вообще не участвует в запросе — проверка не требуется,
 * не все API его используют.
 */
export function isCrmIdMissing(data?: unknown, params?: unknown): boolean {
    const fromData = readCrmIdField(data);
    const fromParams = readCrmIdField(params);

    return (
        (fromData.present && isEmptyCrmIdValue(fromData.value)) ||
        (fromParams.present && isEmptyCrmIdValue(fromParams.value))
    );
}
